import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { InlineEditor } from '@/Domain/components/Action/Lexical/InlineEditor';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/Domain/components/Shared/Form/Form';

export const UrlField = () => {
  const { t } = useTranslation('actions_page');

  const parameters = useWatch({ name: 'parameters' });

  return (
    <FormField
      name="url"
      render={({ field, fieldState }) => (
        <FormItem className="overflow-hidden p-1">
          <FormLabel>{t('sheet.form.api_endpoint.url.label')}</FormLabel>
          <FormControl>
            <InlineEditor
              field={field}
              parameters={parameters}
              error={fieldState.error}
              placeholder={t('sheet.form.api_endpoint.url.placeholder')}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
